import { render, staticRenderFns } from "./SearchResultList.vue?vue&type=template&id=b10969be&scoped=true&"
import script from "./SearchResultList.vue?vue&type=script&lang=js&"
export * from "./SearchResultList.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultList.vue?vue&type=style&index=0&id=b10969be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10969be",
  null
  
)

export default component.exports